import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const featureKeys = [
  { key: 'realtime', icon: '\u26A1' },
  { key: 'multistore', icon: '\uD83C\uDFEA' },
  { key: 'easy', icon: '\uD83D\uDE80' },
  { key: 'secure', icon: '\uD83D\uDD12' },
];

export default function Features() {
  const { t } = useLanguage();

  return (
    <section className="features section" id="features">
      <div className="container">
        <h2 className="section-title">{t('features.title')}</h2>
        <p className="section-subtitle">{t('features.subtitle')}</p>
        <div className="features-grid">
          {featureKeys.map(({ key, icon }) => (
            <div className="feature-card" key={key}>
              <div className="feature-icon">{icon}</div>
              <h3>{t(`features.${key}.title`)}</h3>
              <p>{t(`features.${key}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
